export default {
    setAllConfgirations (state, {config}) {
        state.allConfigurations = config
    },
    SetDefaultPreviewStatus (state, previewStatus) {
        state.isFreePreviewEnabled = previewStatus
    },
    SetCorporateLiveStreamFlag (state, flag) {
        state.enableCorporateLiveStreaming = flag
    },
    setLiveStreamingStatus (state, status) {
        state.enableLiveStreaming = status
    },
    setCorpStreamingURL (state, status) {
        state.CorpLiveStreamingURL = status
    },
    setMessageDuration (state, status) {
        state.messageDuration = status
    },
    setLiveStreamingURL (state, url) {
        state.liveStreamingURL = url
    },
    setHeaderAlertStatus (state, alertStatus) {
        state.showHeaderAlert = alertStatus
    },
    setTrialDays (state, days) {
        state.daysLeft = days
    },
    setCardExpiryDays (state, days) {
        state.cardExpiryDays = days
    },
    setTotalTrialDays (state, days) {
        state.totalTrialDays = days
    },
    setMaintenanceStatus (state, flag) {
        state.isMaintenance = flag
    },
    setEventJoinSwitch (state, mins) {
        state.defEventSwitch = mins
    },
    setPressReleaseData (state, {pressReleases}) {
        state.pressReleaseData = pressReleases
    },
    setMessageBoard (state, {messages}) {
        state.messageBoard = messages
    },
    setAllArticles (state, {articles}) {
        state.allArticles = articles
    },
    setSelectedArticle (state, {article}) {
        state.selectedArticle = article
    },
    setFaqs (state, {faqs}) {
        state.faqs = faqs
    },
    setMembers (state, {members}) {
        state.members = members
    },
    setGiftingText (state, giftingTitle) {
        state.giftingText = giftingTitle
    },
    setShowCustomUnauthBanner (state, flag) {
        state.showCustomUnauthBanner = flag
    },
    setUnauthBannerText (state, bannerText) {
        state.unauthBannerText = bannerText
    },
    setUnauthBannerLink (state, bannerLink) {
        state.unauthBannerLink = bannerLink
    },
    setGiftingLinksStatus (state, status) {
        state.turnOffGifting = status
    },
    setPaidMembershipFlag (state, status) {
        state.paidMembershipService = status
    },
    setProfileCharitySectionFlag (state, status) {
        state.profileCharitySection = status
    },
    setAuthLeftTopBannerMessage (state, msg) {
        state.authLeftTopBannerMessage = msg
    },
    setAuthLeftTopBannerUrl (state, url) {
        state.authLeftTopBannerUrl = url
    },
    setUnauthFindMoreUrl (state, url) {
        state.unauthFindMoreUrl = url
    },
    setShowParticipantFlag (state, url) {
        state.showEventParticipantCount = url
    },
    setAdvisoryBoard (state, { adBoard }) {
        state.advisoryBoard = adBoard
    }
}



// WEBPACK FOOTER //
// ./src/store/configuration/mutations.js